module.exports = __webpack_public_path__ + "img/image8@3x.200ca418.png";